import { useEffect, useRef, useState } from "react";
import { ProductDetailsScreenViewModel } from "../../../../viewmodels/setup/products/ProductDetailsScreenViewModel";

import { connect } from "react-redux";

import * as actions from "../../../../store/actions/index";

import { classNames, withRouter } from "../../../../shared/utility";

import SlideOver from "../../../../components/slideOver/SlideOver";
import EmptyModal from "../../../../components/modals/EmptyModal";

import TableLoadingSkeleton from "../../../../components/shared/TableLoadingSkeleton";
import ProductDetailsForm from "../../../../components/forms/setup/products/ProductDetailsForm";

import { useParams } from "react-router-dom";
import ProductSpecSheet2 from "../../../../components/forms/setup/products/ProductSpecSheet2";
import VendorSkusTable from "../../../../components/forms/setup/products/VendorSkusTable";
import VendorSkuForm from "../../../../components/forms/setup/products/VendorSkuForm";
import ProductDuplicates from "../../../../components/forms/setup/products/ProductDuplicates";
import AuditActionLink from "../../../../components/audit/AuditActionLink";
import ProductPromotionsTab from "../../../../components/forms/setup/products/ProductPromotionsTab";
import ProductRecipeTab from "../../../../components/forms/setup/products/ProductRecipeTab";

const tabs = [
  { name: "Product Details", href: "#" },
  { name: "Specs Sheet", href: "#" },
  { name: "Vendor Skus", href: "#" },
  { name: "Product Duplicate", href: "#" },
  { name: "Promotions", href: "#" },
  { name: "Recipe", href: "#" },
];

function ProductDetailsScreen(props) {
  const { addSnackbar, logout } = props;

  const [currentTab, setCurrentTab] = useState(0);

  const { productId } = useParams();

  const {
    setSlideOver,
    slideOver,
    setEmptyModelOpen,
    emptyModal,
    inventoryTypeOptions,
    getInventoryTypes,
    classTypeOptions,
    categoryOptions,
    boxTypeOptions,
    allergenOptions,
    warehouseOptions,
    warehouseLocationsOptions,
    getClassTypes,
    getCategoryTypes,
    getBoxTypes,
    getAllergens,
    getWarehouses,
    getWarehouseLocations,
    updateProduct,
    product,
    loading,
    getProductDetails,
    graphicsOptions,
    getGraphics,
    onDuplicate,
    getProductColours,
    getProductOdours,
    getProductTastes,
    productColours,
    productOdours,
    productTastes,
    vendorSKUs,
    vendorSKUsLoading,
    getProductVendorSkus,
    supplierOptions,
    getSuppliersForDropdown,
    createVendorSku,
    createVendorSkuInProgress,
    updateVendorSku,
    updateVendorSkuInProgress,
    deleteVendorSku,
    askDeleteVendorSku,
    productDuplicates,
    getProductDuplicates,
    updateProductDuplicate,
    taxRates,
    getTaxRatesForDropdown,
    promotions,
    promotionCustomers,
    promotionsLoading,
    promotionSaving,
    promotionsError,
    getProductPromotions,
    saveProductPromotion,
    setProductPromotionEnabled,
    askDeleteProductPromotion,
  } = ProductDetailsScreenViewModel(logout, productId, addSnackbar);
  const getProductPromotionsRef = useRef(getProductPromotions);
  getProductPromotionsRef.current = getProductPromotions;

  async function runFinalFunction() {
    try {
      // Wait for all async functions to complete
      const results = await Promise.all([
        getInventoryTypes(),
        getClassTypes(),
        getCategoryTypes(),
        getBoxTypes(),
        getAllergens(),
        getWarehouses(),
        getGraphics(),
        getProductColours(),
        getProductOdours(),
        getProductTastes(),
        getTaxRatesForDropdown(),
      ]);

      // Run the final function
      getProductDetails();
    } catch (error) {
      console.error("An error occurred:", error);
    }
  }

  useEffect(() => {
    runFinalFunction();
  }, []);

  useEffect(() => {
    if (currentTab === 2 && productId) {
      getProductVendorSkus();
      if (supplierOptions.length === 0) {
        getSuppliersForDropdown();
      }
    }
  }, [currentTab, productId]);

  useEffect(() => {
    if (currentTab === 3 && product?.id) {
      getProductDuplicates(product.id);
    }
  }, [currentTab, product?.id]);

  useEffect(() => {
    if (currentTab === 4 && productId) getProductPromotionsRef.current();
  }, [currentTab, productId]);

  const handleSearch = (searchTerm) => {
    getProductVendorSkus(searchTerm || null);
  };

  const handleOpenAddModal = () => {
    setEmptyModelOpen({
      childComponent: (
        <VendorSkuForm
          actionCall={createVendorSku}
          setOpen={setEmptyModelOpen}
          inProgress={createVendorSkuInProgress}
          supplierOptions={supplierOptions}
        />
      ),
      open: true,
    });
  };

  const handleEditVendorSku = (vendorSku) => {
    setEmptyModelOpen({
      childComponent: (
        <VendorSkuForm
          actionCall={(values) => updateVendorSku(vendorSku.id, values)}
          setOpen={setEmptyModelOpen}
          inProgress={updateVendorSkuInProgress}
          supplierOptions={supplierOptions}
          isEdit={true}
          vendorSku={vendorSku}
        />
      ),
      open: true,
    });
  };

  const handleDeleteVendorSku = (vendorSku) => {
    askDeleteVendorSku(vendorSku);
  };

  const renderComponent = (index) => {
    switch (index) {
      case 0:
        return (
          <div key={0} className="-mt-2 bg-white p-4">
            <ProductDetailsForm
              product={product}
              actionCall={updateProduct}
              isEdit={true}
              inventoryTypeOptions={inventoryTypeOptions}
              classTypeOptions={classTypeOptions}
              categoryOptions={categoryOptions}
              boxTypeOptions={boxTypeOptions}
              allergenOptions={allergenOptions}
              warehouseOptions={warehouseOptions}
              warehouseLocationsOptions={warehouseLocationsOptions}
              getWarehouseLocations={getWarehouseLocations}
              graphicsOptions={graphicsOptions}
              onDuplicate={onDuplicate}
              productColours={productColours}
              productOdours={productOdours}
              productTastes={productTastes}
              taxRates={taxRates}
            />
          </div>
        );

      case 1:
        return (
          <div key={1} className="p-4">
            <ProductSpecSheet2
              product={product}
              productColours={productColours}
              productOdours={productOdours}
              productTastes={productTastes}
            />
          </div>
        );

      case 2:
        return (
          <div key={2} className="p-4">
            <VendorSkusTable
              vendorSKUs={vendorSKUs}
              loading={vendorSKUsLoading}
              onSearch={handleSearch}
              onOpenAddModal={handleOpenAddModal}
              onEdit={handleEditVendorSku}
              onDelete={handleDeleteVendorSku}
            />
          </div>
        );

      case 3:
        return (
          <div key={3} className="p-4">
            <ProductDuplicates product={product} productDuplicates={productDuplicates} setSlideOver={setSlideOver} setEmptyModelOpen={setEmptyModelOpen} updateProductDuplicate={updateProductDuplicate} />
          </div>
        );

      case 4:
        return (
          <div key={4} className="p-4">
            <ProductPromotionsTab
              productSellingUnit={product.selling_unit_of_measure}
              promotions={promotions}
              customers={promotionCustomers}
              loading={promotionsLoading}
              saving={promotionSaving}
              error={promotionsError}
              onSave={saveProductPromotion}
              onToggle={setProductPromotionEnabled}
              onDelete={askDeleteProductPromotion}
            />
          </div>
        );

      default:
        return (
          <div key={1000} className="-mt-2">
            Could not load page, please try again
          </div>
        );
    }
  };

  return (
    <div>
      <div className="mt-2 px-4 sm:px-8">
        {loading ? (
          <div role="status" aria-label="Loading product details" aria-busy="true" className="card-custom mt-4 bg-white p-4">
            <span className="sr-only">Loading product details</span>
            <div aria-hidden="true"><TableLoadingSkeleton rows={8} columns={4} /></div>
          </div>
        ) : product ? (
          <div className="sm:items-center">
            <div className="sm:flex-auto hide-for-print flex items-center">
              <h1 className="text-2xl font-semibold leading-6 text-gray-900">
                {product.name}
              </h1>
              {productId ? (
                <AuditActionLink
                  slug="product"
                  id={productId}
                  name={product.name}
                />
              ) : null}
            </div>

            {/* tab here */}
            <div className="hide-for-print mt-4 bg-gray-50">
              <div className="sm:hidden">
                <label htmlFor="tabs" className="sr-only">
                  Select a tab
                </label>
                <select
                  id="tabs"
                  name="tabs"
                  className="block w-full border-gray-300 rounded-md"
                  value={tabs[currentTab].name}
                  onChange={(event) => setCurrentTab(tabs.findIndex((tab) => tab.name === event.target.value))}
                >
                  {tabs.map((tab, index) => (
                    <option key={index}>{tab.name}</option>
                  ))}
                </select>
              </div>
              <div className="hidden sm:block">
                <nav
                  className="relative z-0 rounded-lg shadow flex divide-x divide-gray-200"
                  aria-label="Tabs"
                >
                  {tabs.map((tab, index) => (
                    <a
                      key={tab.name}
                      href={tab.href}
                      className={classNames(
                        index === currentTab
                          ? "text-gray-900"
                          : "text-gray-500 hover:text-gray-700",
                        index === 0 ? "rounded-l-lg" : "",
                        index === tabs.length - 1 ? "rounded-r-lg" : "",
                        "group relative min-w-0 flex-1 overflow-hidden bg-white py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10",
                      )}
                      aria-current={index === currentTab ? "page" : undefined}
                      onClick={() => setCurrentTab(index)}
                    >
                      <span>{tab.name}</span>
                      <span
                        aria-hidden="true"
                        className={classNames(
                          index === currentTab
                            ? "bg-indigo-500"
                            : "bg-transparent",
                          "absolute inset-x-0 bottom-0 h-0.5",
                        )}
                      />
                    </a>
                  ))}
                </nav>
              </div>
            </div>

            {/* {tab content starts below} */}
            <div className="px-4 sm:px-0">
              <div className="sm:col-span-9">
                {tabs.map((item, index) =>
                  index === currentTab && index !== 5 ? renderComponent(index) : null,
                )}
                <div hidden={currentTab !== 5}>
                  <ProductRecipeTab
                    key={product.id}
                    productId={Number(product.id)}
                    productName={product.name}
                    productSellingUnit={Number(product.selling_unit_of_measure)}
                    active={currentTab === 5}
                    onUnauthorized={logout}
                  />
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        setSlideOver={setSlideOver}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProductDetailsScreen),
);
